import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import Walter from "../EverestAssets/Avatars/Walter.webp";
import SpamTextsProfilePic from "../EverestAssets/Avatars/PlainAvatar.jpg";
import Osvaldo from "../EverestAssets/Avatars/Osvaldo.webp";
import Darwin from "../EverestAssets/Avatars/Darwin.webp";
import Jacques from "../EverestAssets/Avatars/Jacques.webp";

export const EverestMessageContent: Chat_content[] = [
  {
    icon: Walter,
    name: "Walter",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "What time did you book the taxi for?",
        },
        timestamp: "2025-04-30T09:04:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "5:30pm x",
        },
        timestamp: "2025-04-30T09:12:00.000Z",
        from: "Walter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Ok thanks for booking x",
        },
        timestamp: "2025-04-30T09:14:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Where are you? We're at luggage collection",
        },
        timestamp: "2025-05-01T08:07:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I left my tablets in the bathroom so I went back to fetch them",
        },
        timestamp: "2025-05-01T08:07:00.000Z",
        from: "Walter",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "We'll wait outside",
        },
        timestamp: "2025-05-01T08:11:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Walter, did you two get down alright?",
        },
        timestamp: "2025-06-08T14:32:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Yes we both got down ok and slept at the ranger's lodge last night, Just arrived in Kathmandu.",
        },
        timestamp: "2025-06-08T18:15:00.000Z",
        from: "Walter",
        status: "Read",
      },
    ],
  },
  {
    icon: SpamTextsProfilePic,
    name: "Tecro",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Namaste! Top up your sim with 20,000 Rp today, and enjoy 30 days of FREE WhatsApp usage PLUS 600 minutes of free calls. Stay connected, and seize the deal! 🌐✨…",
        },
        timestamp: "2025-05-01T07:48:00.000Z",
        from: "Tecro",
        status: "Read",
      },
    ],
  },
  {
    icon: Osvaldo,
    name: "Osvaldo",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Hi Osvaldo, are you free for our weekly Amapa call at 3pm today?",
        },
        timestamp: "2025-04-28T09:16:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes I am. Señora, do you have any news from the embassy?",
        },
        timestamp: "2025-04-28T09:18:00.000Z",
        from: "Osvaldo",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I only asked them on Monday, give them a few days to have a thorough check.",
        },
        timestamp: "2025-04-28T09:18:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Ok, señora. Thank you for your kindness.",
        },
        timestamp: "2025-04-28T09:19:00.000Z",
        from: "Osvaldo",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Señora, do you have any news from the embassy?",
        },
        timestamp: "2025-04-30T08:45:00.000Z",
        from: "Osvaldo",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Not yet Osvaldo, but I should be hearing from them soon",
        },
        timestamp: "2025-04-30T10:57:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Señora, still no news?",
        },
        timestamp: "2025-05-01T08:34:00.000Z",
        from: "Osvaldo",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi Osvaldo, I spoke to the Embassy today. They said they couldn’t find any data on Julio Romero so they believe the criminals may have been using a dummy email address. They’ll get back to me if they find anything but at the moment they have nothing to go off.",
        },
        timestamp: "2025-05-01T16:43:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Please señora, offer them money to keep Virna safe. Imagine $300,000 - that’s a lot of money to Ecuadorians, but not to you. I’m sure this would be enough to keep the criminals away from my daughter. My family and I can’t sleep, we are worried sick. I am struggling to do my job",
        },
        timestamp: "2025-05-01T16:56:00.000Z",
        from: "Osvaldo",
        status: "Read",
      },
    ],
  },
  {
    icon: SpamTextsProfilePic,
    name: "Roaming",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Welcome to NEPAL. If you want to use data while you’re here, you’ll need to buy a Zone 1 Power Charge. See our pricing here (it’s free to view)...",
        },
        timestamp: "2025-05-01T07:49:00.000Z",
        from: "Roaming",
        status: "Read",
      },
    ],
  },
  {
    icon: Darwin,
    name: "Darwin",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "Hi mom. Can I call you? I need to ask you about something.",
        },
        timestamp: "2025-04-13T12:16:00.000Z",
        from: "Darwin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi D, I’m in and out of meetings all day, is there any way you could ask me by text?",
        },
        timestamp: "2025-04-13T12:21:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "It’s kinda important, I’d rather speak to you over the phone.",
        },
        timestamp: "2025-04-13T12:22:00.000Z",
        from: "Darwin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Okie dokes. I will call you in about 20 minutes, is that okay?",
        },
        timestamp: "2025-04-13T12:23:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes that's fine",
        },
        timestamp: "2025-04-13T12:26:00.000Z",
        from: "Darwin",
        status: "Read",
      },
      {
        content: {
          type: "missed-call",
          content: "<< Audio Call, duration 10:17 minutes >>",
        },
        timestamp: "2025-04-13T12:38:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Please try and understand my perspective, D. I’m conscious of giving you too much in life, financially, that you lose your drive and purpose. It’s important that we all face moments of struggle in our lives, do you understand? They can be the making of us, and I feel that this is your moment.",
        },
        timestamp: "2025-04-13T12:39:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Mom, this isn’t about drive or purpose. I get what you’re saying but I need your help right now. I have nowhere else to go",
        },
        timestamp: "2025-04-13T12:42:00.000Z",
        from: "Darwin",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "You’ll work it out, I know you will.",
        },
        timestamp: "2025-04-13T12:44:00.000Z",
        from: "Nancy",
        status: "Read",
      },
    ],
  },
  {
    icon: Jacques,
    name: "Jacques",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Coucou, my love. Will you join me at Cannes next week? I have been invited onto the judging panel.",
        },
        timestamp: "2025-04-02T10:14:00.000Z",
        from: "Jacques",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I don’t know if I will make it. Things are busy with Amapa.",
        },
        timestamp: "2025-04-02T10:32:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Please come, my sweet. I will be there for 2 weeks all on my own and we can make it nice. It’s important for the documentary too. Everyone in the movie business will be there. We can speak to some important distributors and critics to get them behind the project.",
        },
        timestamp: "2025-04-02T10:38:00.000Z",
        from: "Jacques",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I’ll look into it, but I can’t make any promises",
        },
        timestamp: "2025-04-02T10:40:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Ok. I miss you",
        },
        timestamp: "2025-04-02T10:42:00.000Z",
        from: "Jacques",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Me too",
        },
        timestamp: "2025-04-02T10:43:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I will fly into Cannes for a few days on the 9th. Is that okay for you? Let’s just arrange some meetings with some high profile industry figures for those days. Will you find us a hotel?",
        },
        timestamp: "2025-04-05T18:42:00.000Z",
        from: "Nancy",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Great news! See you then",
        },
        timestamp: "2025-04-05T18:43:00.000Z",
        from: "Jacques",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I’ve already found us a beachfront apartment. It’s a friend’s place, but she will not be there for this month so she said I could stay",
        },
        timestamp: "2025-04-05T18:43:00.000Z",
        from: "Jacques",
        status: "Read",
      },
    ],
  },
];
